import 'semantic-ui-css/semantic.min.css';
import 'src/asset/css/admin.custom.css';
import * as React from "react";
import * as Modal from 'react-modal';
import { BrowserRouter, Route, Redirect, Switch } from 'react-router-dom';
import {Layout} from "../layout/Layout";
import { IApiResponseDto } from 'src/core/dto/common/ApiResponseDto';
import { ScaleLoader } from 'react-spinners';
import {Dashboard} from "../../screen/admin/dashboard/Dashboard";
import {AccountApiService} from "../../core/api/account/AccountApiService";
import {VillageOrganization} from "../../screen/admin/organization/VillageOrganization";
import {DusunOrganization} from "../../screen/admin/organization/DusunOrganization";
import {StaffPost} from "../../screen/admin/post/StaffPost";
import {GalleryPost} from "../../screen/admin/post/GalleryPost";
import {AboutPost} from "../../screen/admin/post/AboutPost";
import {AnnouncementPost} from "../../screen/admin/post/AnnouncementPost";
import {AgendaPost} from "../../screen/admin/post/AgendaPost";
import {NewsPost} from "../../screen/admin/post/NewsPost";
import {SttSubOrganization} from "../../screen/admin/organization/sub-organization/SttSubOrganization";
import {ShantiSubOrganization} from "../../screen/admin/organization/sub-organization/ShantiSubOrganization";
import {GongSubOrganization} from "../../screen/admin/organization/sub-organization/GongSubOrganization";
import {PkkSubOrganization} from "../../screen/admin/organization/sub-organization/PkkSubOrganization";
import {CitizenReport} from "../../screen/admin/report/CitizenReport";
import {AspirationReport} from "../../screen/admin/report/AspirationReport";

interface IProps {
    componentName?: string;
}

interface IState {
    isAuthenticated: boolean;
    isLoadingAuthStatus: boolean;
}

export class AdminArea extends React.Component<IProps, IState> {

    private readonly accountApiService = new AccountApiService();

    constructor(props: IProps) {
        super(props);

        this.state = {
            isAuthenticated: false,
            isLoadingAuthStatus: true
        };

    }

    public componentDidMount = () => {
        this.fetchAuthStatus();
    };

    public render() {

        if (this.state.isLoadingAuthStatus) {
            return (
                <div>
                    <Modal
                        ariaHideApp={false}
                        isOpen={true}
                        style={{
                            content: {
                                backgroundColor: "transparent",
                                border: "none",
                                top: '50%',
                                left: '50%',
                                right: 'auto',
                                bottom: 'auto',
                                marginRight: '-50%',
                                transform: 'translate(-50%, -50%)',
                                maxWidth: '1200px',
                                maxHeight: window.innerHeight - 100
                            }
                        }}>

                        <ScaleLoader
                            sizeUnit={"px"}
                            size={300}
                            color={'#0098db'}
                            loading={true} />

                    </Modal>
                </div>
                );

        } else if (!this.state.isLoadingAuthStatus && !this.state.isAuthenticated) {
            return (
                <Route
                    // tslint:disable-next-line: jsx-no-lambda
                    render={(props: any) =>
                        <Redirect
                            to={{
                                pathname: "/login",
                                state: { from: props.location }
                            }}
                        />
                    }
                />
            );

        } else if (!this.state.isLoadingAuthStatus && this.state.isAuthenticated) {
            return (
                <div className="admin-area">
                    <BrowserRouter>

                        <Layout>
                            <Switch>
                                <Route exact={true} path='/admin' component={Dashboard}/>
                                <Route exact={true} path='/admin/about' component={AboutPost}/>
                                <Route exact={true} path='/admin/announcement' component={AnnouncementPost}/>
                                <Route exact={true} path='/admin/agenda' component={AgendaPost}/>
                                <Route exact={true} path='/admin/news' component={NewsPost}/>
                                <Route exact={true} path='/admin/village/organization' component={VillageOrganization} />
                                <Route exact={true} path='/admin/dusun' component={DusunOrganization} />
                                <Route exact={true} path='/admin/village/staff' component={StaffPost} />
                                <Route exact={true} path='/admin/village/gallery' component={GalleryPost} />
                                <Route exact={true} path='/admin/dusun/stt' component={SttSubOrganization} />
                                <Route exact={true} path='/admin/dusun/sekaa-shanti' component={ShantiSubOrganization} />
                                <Route exact={true} path='/admin/dusun/sekaa-gong' component={GongSubOrganization} />
                                <Route exact={true} path='/admin/dusun/pkk' component={PkkSubOrganization} />
                                <Route exact={true} path='/admin/citizen-report' component={CitizenReport} />
                                <Route exact={true} path='/admin/aspiration-report' component={AspirationReport} />
                            </Switch>
                        </Layout>

                    </BrowserRouter>
                </div>
            );

        } else {
            return (<div/>);
        }

    }

    private fetchAuthStatus = () => {

        this.setState({
            isLoadingAuthStatus: true
        });

        this.accountApiService.checkAuth()
            .then((data: IApiResponseDto) => {
                this.setState({
                    isLoadingAuthStatus: false,
                    isAuthenticated: true
                });

            }).catch((data: IApiResponseDto) => {
                this.setState({
                    isLoadingAuthStatus: false,
                    isAuthenticated: false
                });

            });
    }

}


// WEBPACK FOOTER //
// ./src/component/area/AdminArea.tsx